import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ThemeMode } from '~/types/config';

interface HeaderAlertProps {
  message: string;
  link?: { href: string; label: string };
}

const HeaderCustomAlert: React.FC<HeaderAlertProps> = ({ message, link }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === ThemeMode.DARK;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isDark ? 'rgba(254, 200, 75, 0.1)' : 'rgba(254, 200, 75, 0.25)',
        color: isDark ? '#FEC84B' : '#B8860B',
        padding: '8px 16px',
        fontSize: '0.875rem',
      }}
    >
      {message}
      {link && (
        <>
          {' '}
          <a
            href={link.href}
            target="_blank"
            rel="noreferrer"
            style={{ color: 'inherit', fontWeight: 'bold', marginLeft: '4px' }}
          >
            {link.label}
          </a>
          .
        </>
      )}
    </Box>
  );
};

export default HeaderCustomAlert;
